// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3wApU","buttons":"RemoveExpirationActionButtons_buttons__1fH-E"};